<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card>
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse activeKey="1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Status</label>
                  <a-select v-model="status" placeholder="Ex. Active" class="width-full" allowClear>
                    <a-select-option value="Aktif">Active</a-select-option>
                    <a-select-option value="Non Aktif">Non Active</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Used For</label>
                  <a-select v-model="peruntukanSearch" class="width-full" initialValue="delivered"
                    placeholder="Ex. Customer" allowClear>
                    <a-select-option v-for="item in peruntukan" :key="item.id">{{ item.value }}</a-select-option>
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList :loading="loading" :title="judulHeader" :manifestLink="getManifestLink" :dataList="searching"
        :estimasi="false" :rab="rabEnabled" :route="route" :disabledCreateEditLink="true" />
    </a-col>
    <a-modal v-model="rabVisible" @ok="historyToggle" :footer="null">
      <span slot="title">&nbsp;RAB Information</span>
      <a-row :gutter="8">
        <a-col :span="24">
          <div class="m-display-flex flex-row space-between" style="padding: 7px">
            <span>Budget:</span>
            <span class="m-list-desc">{{
              formatCurrency(informasi_rab.currency, informasi_rab.total)
            }}</span>
          </div>
          <div class="m-display-flex flex-row space-between" style="padding: 7px">
            <span>Allocation :</span>
            <span class="m-list-desc">{{
              formatCurrency(informasi_rab.currency, informasi_rab.pemakaian)
            }}</span>
          </div>
          <div class="m-display-flex flex-row space-between" style="padding: 7px">
            <span>Realization :</span>
            <div class="tright">
              <span class="m-list-desc">{{
                formatCurrency(informasi_rab.currency, informasi_rab.realisasi)
              }}</span>
            </div>
          </div>
          <a-divider class="margin-small" />
          <div class="m-display-flex flex-row space-between" style="padding: 7px">
            <b>
              <span>Total Realization Budget :</span>
            </b>
            <div class="tright">
              <b>
                <span class="m-list-desc">{{
                  formatCurrency(
                    informasi_rab.currency,
                    informasi_rab.sisa_realisasi
                  )
                }}</span>
              </b>
            </div>
          </div>
          <div class="m-display-flex flex-row space-between" style="padding: 7px">
            <b>
              <span>Remaining Budget :</span>
            </b>
            <b>
              <span class="m-list-desc">{{
                formatCurrency(informasi_rab.currency, informasi_rab.sisa)
              }}</span>
            </b>
          </div>
          <br />
        </a-col>
      </a-row>
    </a-modal>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "List",
  props: ["route"],
  mixins: [CurrencyFormat],
  data() {
    return {
      rabVisible: false,
      loading: true,
      search: "",
      status: undefined,
      dataList: [],
      peruntukan: [],
      peruntukanSearch: undefined,
      rabValue: "",
      urlData: "",
      rabEnabled: false,
      judulHeader: "",
      informasi_rab: {
        total: 0,
        pemakaian: 0,
        sisa: 0,
        currency: null,
      },
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let output = this.dataList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ &&
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }

      if (this.status) {
        output = output.filter((item) => {
          return item.status === this.status;
        });
      }

      if (this.peruntukanSearch) {
        output = output.filter(
          (obj) =>
            obj.peruntukan
              .toLowerCase()
              .indexOf(self.peruntukanSearch.toLowerCase()) >= 0
        );
      }

      return output;
    },
    getManifestLink() {
      if (localStorage.getItem("nvpn") === "/hrd") {
        return "SpclProyekRabManifestHrd";
      } else if (localStorage.getItem("nvpn") === "/direktur") {
        return "SpclProyekRabManifestDir";
      } else if (localStorage.getItem("nvpn") === "/pimpro") {
        return "SpclProyekRabManifestPimpro";
      } else if (localStorage.getItem("nvpn") === "/marketing") {
        return "SpclProyekRabManifestMar";
      } else if (localStorage.getItem("nvpn") === "/purchasing") {
        return "SpclProyekRabManifestPurchasing";
      } else if (localStorage.getItem("nvpn") === "/ga") {
        return "SpclProyekRabManifestGA";
      } else if (localStorage.getItem("nvpn") === "/akuntansiKeuangan") {
        return "SpclProyekRabManifestAcc";
      } else if (localStorage.getItem("nvpn") === "/keuangan") {
        return "SpclProyekRabManifestKeu";
      } else if (localStorage.getItem("nvpn") === "/vpf") {
        return "SpclProyekRabManifestVpf";
      } else {
        return "SpclProyekRabManifest_";
      }
    },
  },
  created() {
    if (
      localStorage.getItem("nvpn") === "/purchasing" ||
      localStorage.getItem("nvpn") === "/ga"
    ) {
      this.urlData = "monitoring/proyek";
      this.judulHeader = "Project List";
      this.rabEnabled = false;
    } else if (localStorage.getItem("nvpn") === "/hrd") {
      this.urlData = "monitoring/proyek_rab";
      this.judulHeader = "Project List";
      this.rabEnabled = false;
    } else {
      this.urlData = "monitoring/proyek_rab";
      this.judulHeader = "Project";
      this.rabEnabled = true;
    }

    this.fetchPeruntukan();
    this.fetchData();
  },
  methods: {
    moment,
    async fetchData() {
      await axios({
        method: "get",
        url: this.$serviceUrl + this.urlData,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
        params: {
          tlc: this.getAuth.username,
          id: localStorage.getItem("nvky"),
        },
      })
        .then((response) => {
          response.data.data.forEach((data) => {
            this.dataList.push({
              searchQ:
                data.kode_proyek +
                " " +
                data.user_pembuat +
                " " +
                data.perusahaan +
                " " +
                data.klien +
                " " +
                data.pimpinan_proyek +
                " " +
                this.moment(data.tgl_buat)
                  .format(this.getDefaultDateFormat)
                  .toString(),
              peruntukan: data.peruntukan,
              title: data.kode_proyek,
              subdesc: [
                data.nama_project,
                data.tgl_start && data.tgl_finish
                  ? this.moment(
                    data.tgl_start,
                    this.getStandartFormatDate
                  ).format(this.getDefaultDateFormat) +
                  " s/d " +
                  this.moment(
                    data.tgl_finish,
                    this.getStandartFormatDate
                  ).format(this.getDefaultDateFormat)
                  : " - ",
                data.perusahaan,
                [
                  { label: "Klien", value: data.klien },
                  { label: "Pimpro", value: data.pimpinan_proyek },
                ],
              ],
              status: data.status,
              id: data.kode_proyek,
            });
          });
          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    fetchPeruntukan() {
      axios({
        method: "get",
        url: this.$serviceUrl + "main/peruntukan",
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.peruntukan = response.data.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    historyToggle(item) {
      if (this.dataList) {
        let rabfilter = this.dataList.filter(
          (obj) => (obj ? obj.id : " ") == item.id
        );
        this.informasi_rab = {
          total: rabfilter[0].total ? rabfilter[0].total : 0,
          pemakaian: rabfilter[0].pemakaian ? rabfilter[0].pemakaian : 0,
          sisa: rabfilter[0].sisa ? rabfilter[0].sisa : 0,
          realisasi: rabfilter[0].realisasi ? rabfilter[0].realisasi : 0,
          sisa_realisasi: rabfilter[0].sisa_realisasi
            ? rabfilter[0].sisa_realisasi
            : 0,
          currency: rabfilter[0].currency,
        };
        this.rabVisible = !this.rabVisible;
      }
    },
  },
  mounted() {
    Event.$on("handleRab", this.historyToggle);
  },
};
</script>

<style>
.highlightText {
  background: yellow;
}
</style>